import { render, staticRenderFns } from "./sdjtFooter.vue?vue&type=template&id=3789ef7e&scoped=true"
import script from "./sdjtFooter.vue?vue&type=script&lang=js"
export * from "./sdjtFooter.vue?vue&type=script&lang=js"
import style0 from "./sdjtFooter.vue?vue&type=style&index=0&id=3789ef7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789ef7e",
  null
  
)

export default component.exports